import React, {useMemo} from "react";
import {useTimeseriesModels1AvalancheCountQuery} from "./query";
import {useTranslation} from "react-i18next";
import ObservedAvalanches from "./ObservedAvalanches";
import MDTypography from "../../materialDashboard/components/MDTypography";
import MDBox from "../../materialDashboard/components/MDBox";


const MicroZoneGraphs = ({microZoneId, microZoneCode}) => {
    const {t} = useTranslation("graphs");

    const timeseriesQuery = useTimeseriesModels1AvalancheCountQuery(microZoneId);

    const data = useMemo( () => (
        timeseriesQuery.data ?
            timeseriesQuery.data.dates.map((date, index) => {
                return {
                    date: new Date(date),
                    models1ReportingAvalancheCount: timeseriesQuery.data.models1ReportingAvalancheCount?.[index],
                    models1ReportingNoAvalancheCount: timeseriesQuery.data.models1ReportingNoAvalancheCount?.[index],
                }
            })
            :
            []
    ), [timeseriesQuery.data])

    return <MDBox sx={{width: "100%", maxWidth: "100%", minWidth: 0, display: "flex", flexDirection: "column", gap: 4 }}>
        <MDTypography variant="h5">{t('observedAvalanches.title')}</MDTypography>
        <ObservedAvalanches data={data} microZoneName={microZoneCode}/>;
    </MDBox>
}


export default MicroZoneGraphs;